import { Button } from "@material-ui/core";
import en from "../../../lang/en-us";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getPortfolio } from "../../../store/actions/portfolio";
import { RootStateType } from "../../../store/reducers";
import {
  sendPhoneOTP as sendOtp,
  sendEmailOTP,
  updateEmail,
} from "../../../store/actions/nct";
import {
  getPortfoliosFilteredData,
  portfoliosByMinorStatus,
  portfoliosByModeOfHolding,
  portfoliosByTransactionResource,
} from "../../home/portfolios/utils";
import { getErrorMessage, getInvestorFunds } from "../portfolios/utils";
import { NoteModals } from "../../../lib/NoteModals";
import { TableColumn, TableWithCollapse } from "../../../lib/DataTable";
import { NOMINEE } from "../../../store/types/nct";
import {
  UPDATE_EMAIL,
  OTP_ACTIONS,
  REGISTER_WITH_EMAIL,
} from "../../../utils/constants";
import NoFoliosFound from "./../NoFoliosFound";
import { useTableWithCollapse } from "../../../lib/DataTable/customHooks";
// import { ActionHeader, FaqLink } from '../index';
import { nextScreen } from "../ChangeMobile/flow";
import { getMatchAndUnMatchedFunds } from "../../../utils/utilityFunctions";
import { fetchInvestorDetails } from "../../../store/actions/nct";
import { SubmitButtonWithLoader } from "../../../lib/Button";
import MenuItem from "@material-ui/core/MenuItem";
import CustomizedSelect from "../transactions/customizedSelect";
import React from "react";
import { BackArrow } from "../UpdateNominee/SelectedFolios";

import { mohMap } from "../UpdateNominee";
const { dashboard } = en;

const columns: TableColumn[] = [
  { field: "folio", headerName: "Folio" },
  { field: "amcName", headerName: "Fund House", width: 300 },
  { field: "investorName", headerName: "Primary Holder", width: 250 },
  {
    field: "modeOfHolding",
    headerName: "Mode of Holding",
    valueGetter: ({ row }) => {
      if (row.modeOfHolding === null) {
        return "NA";
      }
      const moh = mohMap[row.modeOfHolding];
      if (moh) {
        return moh;
      } else {
        return "Others";
      }
    },
    width: 150,
  },
  { field: "mobile", headerName: "Mobile No.", width: 250 },

  { field: "email", headerName: "Email Address", width: 200 },
];

export interface RowInfoType {
  id: string | number;
  amcName: string;
  investorName?: string;
  email?: string;
  amc?: string;
  schemeNames?: string[];
  mobile?: string;
  assetType?: string[];
  isDisabled?: boolean;
  folio?: string;

  nominees?: NOMINEE[];

  taxStatusLabel?: string;
}

function ChangeEmailList(props: any) {
  const { enteredEmail: email, emailRelationship } = props.location.state || {};
  const [loading, setLoading] = useState<boolean>(false);
  const [rowData, setRowData] = useState<RowInfoType[]>([]);
  const [uniqueMobileNo, setUniqueMobileNo] = useState([]);
  const [selectMobile, setSelectMobile] = useState("");
  const [filteredData, setFilterdData] = useState<RowInfoType[]>([]);
  const { tableRows, tableColumns, selectedRows, setSelectedRows } =
    useTableWithCollapse<RowInfoType[]>({
      rows: filteredData,
      columns,
      loading,
    });
  const [show, setShow] = useState<boolean>(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const goTo = nextScreen(props.match.path, "email");
      const { pan = "", pekrn = "", mobile = "" } = props;
      const foliosToUpdate = selectedRows.filter(
        (fund) => fund.email !== email
      );
      // const action = emailRegisteredUser()
      //     ? OTP_ACTIONS.changeEmail
      //     : OTP_ACTIONS.changeMobile;
      const investorName = props.investorData.invname;
      const investorPan = props.investorData.PAN;

      const investor = props.investors.find(
        (item: any) =>
          item.Name.toLowerCase() === investorName.toLowerCase() ||
          item.Pan.toLowerCase() == investorPan.toLowerCase()
      );

      const newData = foliosToUpdate.map((item) => ({
        folio: item.folio,
        amc: item.amc,
        amc_name: item.amcName,
      }));

      const payload: {
        email: string;
        newEmail: string;
        mobile: string;
        image: any | null;
        relation: string;
        pan: string;
        distributor_id: string;
        data: any;
      } = {
        email: investor.Email,
        newEmail: email,
        mobile: selectMobile,
        image: null,
        relation: emailRelationship,
        pan: investorPan,
        distributor_id: props.token,
        data: newData,
      };

      if (selectMobile === "N/A") {
        props.history.replace(
          "/new-transaction/nct-type/phygital/change-email-document",
          {
            payload: payload,
          }
        );
        return;
      }

      const res = await props.updateEmail(payload);

      alert(
        `Request with request Id ${res.req_id}  for update email address link has been sent to investor mobile number`
      );
      props.history.push("/new-transaction/nct-types");

      // if (foliosToUpdate.length) {
      //   let res = await props.sendOtp({
      //     pan,
      //     pekrn,
      //     action: OTP_ACTIONS.changeEmail,
      //   });
      //   props.history.replace(goTo, {
      //     foliosToUpdate: selectedRows.filter((fund) => fund.email !== email),
      //     ...(props?.location?.state || {}),
      //     action: OTP_ACTIONS.changeEmail,
      //     ...(res || {}).body,
      //   });
      // }
    } catch (err: any) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (!(props.email || email)) {
  //     props.history.replace("/");
  //   }
  // }, []);

  useEffect(() => {
    async function fetchPortfolio() {
      try {
        setLoading(true);
        const { pan = "", pekrn = "", mobile = "", reqId = "" } = props;

        // await props.getPortfolio({
        //   pan,
        //   pekrn,
        //   mobile,
        //   reqId,
        // });
        const payload = {
          pan: props.investorData.PAN,
          brokercode: props.token,
        };
        const { body: investorDetails = {} } = await props.fetchInvestorDetails(
          payload
        );
        const { success: nomineeFunds = [] } = investorDetails;
        const filters = [
          portfoliosByModeOfHolding,
          portfoliosByMinorStatus,
          portfoliosByTransactionResource,
        ];
        const funds = getMatchAndUnMatchedFunds(
          filters,
          getInvestorFunds(nomineeFunds),
          true
        ).map((fund) => {
          return { ...fund, error: getErrorMessage(fund, filters) };
        });
        const { nomineeFunds: _nomineeFunds = [], otherFunds = [] } =
          funds.reduce((prev: any, fund: RowInfoType) => {
            if (fund?.nominees?.length) {
              return {
                ...prev,
                nomineeFunds: [...(prev.nomineeFunds ?? []), fund],
              };
            }
            return { ...prev, otherFunds: [...(prev.otherFunds ?? []), fund] };
          }, []);

        const rows: RowInfoType[] = [...otherFunds, ..._nomineeFunds].map(
          (item) => ({
            folio: item.folio,
            amc: item.amc,
            amcName: item.amcName,
            email: item.email,
            id: item.id,
            investorName: item.investorName,
            mobile: item.mobile || "N/A",
            assetType: item.assetType,
            modeOfHolding: item.modeOfHolding,
            isDisabled: item.isDisabled,
            error: item.error,
          })
        );
        // .filter((item) => item.email != email);

        // setRowData([...otherFunds, ..._nomineeFunds]);
        // setSelectedRows([...otherFunds, ..._nomineeFunds]);
        const mobileNumbers: any = [];

        for (let i = 0; i < rows.length; i++) {
          if (rows[i].mobile) {
            const mobile = rows[i].mobile.trim() || "N/A";
            if (!mobileNumbers.includes(mobile)) {
              mobileNumbers.push(mobile);
            }
          }
        }
        setUniqueMobileNo(mobileNumbers);
        setRowData(rows);
        // setSelectedRows(rows);
        setLoading(false);
      } catch (err: any) {
        alert(err.message);
        setLoading(false);
      }
    }
    fetchPortfolio();
  }, []);

  useEffect(() => {
    setSelectMobile(uniqueMobileNo[0] || "");
    const filteredData = rowData.filter(
      (item) => item.mobile == uniqueMobileNo[0]
    );
    setFilterdData(filteredData);
    // setRowData(filteredData);
    // setSelectedRows(filteredData);
  }, [uniqueMobileNo, rowData]);

  const handleChangeMobileNumber = (e: any) => {
    setSelectMobile(e.target.value);
    const filteredData = rowData.filter(
      (item) => item.mobile == e.target.value
    );
    setFilterdData(filteredData);
    // setRowData(filteredData);
    setSelectedRows([]);
  };

  return (
    <>
      <div className="curved-bg email-component" style={{ padding: 0 }}>
        <BackArrow history={props.history} />
        {/* <ActionHeader header={dashboard.changeEmail.changeEmailHeading} /> */}
        <h5
          style={{
            fontFamily: "OpenSans-SemiBold",
            fontSize: "15px",
            lineHeight: "18px",
            color: " #4f4f4f",
            //marginBottom: "25px",
          }}
        >
          {dashboard.changeEmail.List.emailNote}
        </h5>
        <div
          className="appbar-div dual-margin input-name-responsive"
          style={{ display: "flex", gap: "1%" }}
        >
          <div
            className="input-name input-name-sizing-responsive"
            style={{ alignItems: "center", display: "flex", marginBottom: "0" }}
          >
            Select Mobile Number
          </div>
          <CustomizedSelect
            handleChange={handleChangeMobileNumber}
            value={selectMobile}
            emailStyle={true}
            // inputRef={(ele) => (this.reportTypeField = ele)}
            // isError={reportType.isError}
            // errorMessage={reportType.errorMessage}
            // isShowError={reportType.isError}
            //placeholder="Select Report Type"
          >
            {uniqueMobileNo.map((item) => (
              <MenuItem value={item} key={item}>
                {item}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>

        <div className="curved-bg-content curved-bg-table-outer email-table-outer">
          <div className="curved-bg-content-table">
            <div className="curved-table-content email-table">
              <div
                className="curved-table-content-bottom "
                style={{
                  width: "100%",
                  boxShadow: "lightgrey 0px 0px 2px 0px",
                }}
              >
                {!filteredData.length && !loading ? (
                  <NoFoliosFound
                    extraClass="consolidation-error"
                    icon="error-red"
                    info={"No Portfolios found"}
                  />
                ) : (
                  <TableWithCollapse
                    setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows}
                    rows={tableRows}
                    columns={tableColumns}
                    toolTipTextGetter={({ row }) =>
                      row.isDisabled ? row.error : ""
                    }
                    checkBoxEnabled
                    toolTipEnabled
                  />
                )}
              </div>
            </div>
            {/* <FaqLink section={UPDATE_EMAIL} history={props.history} /> */}
          </div>
          {!!tableRows.length && (
            <div className="curved-bg-content-inner-bottom">
              <div className="table-submit">
                <SubmitButtonWithLoader
                  type="submit"
                  loading={loading}
                  labelWhileLoading={"Submitting"}
                  className="customBtn"
                  label={"Submit"}
                  disabled={
                    loading ||
                    !selectedRows.filter(
                      (fund) => fund.email?.toLowerCase() !== email?.toLowerCase()
                    ).length
                  }
                  onClick={() => {
                    handleSubmit();
                  }}
                />
              </div>
            </div>
          )}
          <NoteModals
            showModal={show}
            heading={dashboard.noteModals.otpAuth.heading}
            // mobileOrEmail={maskMobileNumber(props.mobile)}
            info={`${dashboard.noteModals.otpAuth.subHeadingMail} ${
              email || props.email
            }. ${dashboard.noteModals.otpAuth.confirmText}`}
            proceedBtn={dashboard.noteModals.otpModal.proceedText}
            cancelBtn={dashboard.noteModals.otpModal.cancelText}
            onProceed={handleSubmit}
            onCancel={() =>
              props.history.push("change-email-document", {
                foliosToUpdate: selectedRows.filter(
                  (fund) => fund.email !== email
                ),
              })
            }
          />
        </div>
      </div>
    </>
  );
}

export default connect(
  ({ authReducer, portfolio, investor }: RootStateType) => ({
    ...authReducer,
    ...portfolio,
    ...investor,
  }),
  {
    fetchInvestorDetails,
    // getPortfolio,
    sendOtp,
    updateEmail,
  }
)(ChangeEmailList);

// export default {};
